export function AsssetDashLogo({
  alternateColors = false,
  forceDark = false,
  size = "default",
  forceWhite = false,
}) {
  //   const router = useRouter();

  let textSize;
  if (size === "default") {
    textSize = "text-xl";
  } else if (size === "large") {
    textSize = "text-3xl";
  }

  let textClass = "text-white";
  if (forceDark) textClass = "text-black";

  return (
    <div
      className={`${textSize} leading-logo  cursor-pointer ${textClass} `}
      onClick={() => {
        // router.push("/");
      }}
    >
      Asset
      <span
        className={`${!alternateColors ? "text-price-green" : ""} font-bold`}
      >
        Dash
      </span>
    </div>
  );
}
